import { provideRouter, Routes, withInMemoryScrolling } from '@angular/router';
import {
  APP_ID,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { SsWebSocketsModule } from './core/vendor/ss-web-sockets/ss-web-sockets.module';
import { provideNgxMask } from 'ngx-mask';
import {
  EVENT_MANAGER_PLUGINS,
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
  withNoHttpTransferCache,
} from '@angular/platform-browser';
import { ContentUpdaterService } from './core/services/content-updater/content-updater.service';
import { CookieService } from 'ngx-unificator/services';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { GlobalErrorHandler } from './core/helpers/global-error-handler';
import { CacheControlInterceptor } from './core/interceptors/cache-control.interceptor';
import { HostRequestsInterceptor } from './core/interceptors/host-requests.interceptor';
import { abTestList } from './core/ab-test/ab-test.data';
import { provideABTest } from './core/ab-test/ab-test';
import { GlobalStore } from './core/store';
import { provideStoreInitializer } from 'ngx-unificator/store';
import { provideInitializer } from './core/initializer/initializer.queue';
import { DecimalPipe } from '@angular/common';
import { provideBrandConfig } from './core/services/brand-config/brand-config.provider';
import { HammerEventsPlugin } from './core/helpers/hammer.manager';
import { provideBotRules } from './core/providers/bot-rules.provider';
import { CustomTransferCacheInterceptor } from './core/interceptors/custom-transfer-cache.interceptor';

const routes: Routes = [
  {
    path: '',
    children: [{ path: '', loadChildren: () => import('./page/page.module').then((m) => m.PageModule) }],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideStoreInitializer(GlobalStore),
    provideInitializer(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideBrandConfig(),
    provideABTest(abTestList),
    provideBotRules(),
    provideClientHydration(withIncrementalHydration(), withEventReplay(), withNoHttpTransferCache()),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })),
    importProvidersFrom(SsWebSocketsModule),
    ContentUpdaterService,
    CookieService,
    DecimalPipe,
    provideNgxMask(),
    { provide: APP_ID, useValue: '21bit' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: EVENT_MANAGER_PLUGINS, useClass: HammerEventsPlugin, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HostRequestsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomTransferCacheInterceptor,
      multi: true,
    },
  ],
};
